import React, { useEffect, useState } from "react";
import { Button, Dropdown, Form, InputGroup } from "react-bootstrap";
import "../../assets/stylesheet/multiSelectInputType.css";
import baseUrl from "../../services/baseUrl";
import ApiRequest from "../../services/apiService";
import { ShowToastUtil } from "../../utilities/showToastUtil";
import { options } from "numeral";
import GetUserData from "../../utilities/getUserDetails";
import { parseJSON } from "date-fns";
import { ClipLoader } from "react-spinners"; // Import the ClipLoader

const SingleSelectTouchpointDropdown = ({ onTouchPointSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [touchpoints, setTouchpoints] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState(
    localStorage.getItem('touchpointFilter') ? { TouchpointName: localStorage.getItem('touchpointFilter') } : null
  );
  const [userData, setUserData] = useState(GetUserData() || {});
  const [isLoading, setIsLoading] = useState(false);

  const placeholder = selectedItem ? selectedItem.TouchpointName : "Select Touchpoint";

  const fetchTouchpointData = async () => {
    setIsLoading(true);
    try {
      const params = new URLSearchParams({
        queryMode: 'fetchTouchpoints',
        touchpointSearchFilter: searchTerm,
        projectFilter: localStorage.getItem('projectFilter') || '',
        userRole: userData.UserRole,
        userCode: userData.UserCode
      });
      const url = `${baseUrl()}/nps/GetNpsGlobalFilters?${params.toString()}`;
      const responseData = await ApiRequest({
        apiLink: url,
        method: "GET",
      });
      if (responseData.Data && responseData.IsSuccess) {
        setIsLoading(false);
        const data = responseData.Data;
        setTouchpoints(data.Touchpoints || []);
      } else {
        console.log("No data available for selected range");
        setIsLoading(false);
        return;
      }
    } catch (error) {
      console.error("Error fetching Touchpoint Filters data:", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchTouchpointData();
  }, []);

  useEffect(() => {
    fetchTouchpointData();
  }, [searchTerm]);

  const handleSelect = (touchpoint) => {
    onTouchPointSelect(touchpoint.TouchpointName);
    setSelectedItem(touchpoint);
    setIsOpen(false);
  };

  const clearTouchpointFilter = () => {
    setSelectedItem('');
    onTouchPointSelect('');
    localStorage.removeItem("touchpointFilter");
    window.location.reload();
  };

  return (
    <div className="d-flex align-items-center">
      <Dropdown
        className="singleSelectTouchpoint"
        show={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
      >
        <Dropdown.Toggle
          as={Button}
          variant="outline-secondary"
          className="text-right transparent-background"
        >
          {placeholder}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={clearTouchpointFilter}
            as="div">
            <Form.Check
              type="checkbox"
              label="Deselect"
              checked={!selectedItem}
              onClick={clearTouchpointFilter}
              title="Deselect the current selection"
            />
          </Dropdown.Item>
          <Dropdown.Item as="div">
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
              />
            </InputGroup>
          </Dropdown.Item>
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center p-3">
              <ClipLoader size={35} color={"#123abc"} loading={isLoading} />
            </div>
          ) : (
            touchpoints.map((option) => (
              <Dropdown.Item
                key={option.TouchpointId}
                as="div"
                onClick={() => handleSelect(option)}
              >
                <div className="dropdown-text">
                  {option.TouchpointName}
                </div>
              </Dropdown.Item>
            ))
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default SingleSelectTouchpointDropdown;
